// Filenames under /history. Note: macOS screenshot names use a narrow no-break
// space (U+202F) before AM/PM, not a regular space.
const NNBSP = '\u202F';

export const HISTORY_IMAGES = [
  '121220250525_2357_Antique Board Game Interface_remix_01jw5p1gj1e9qarn0vpe7dnmhj.jpg',
  '20250526_0007_Antique Board Game_remix_01jw5pmk0jf0hthv4fsrga9jq4.jpg',
  `Screenshot 2024-06-11 at 3.38.48${NNBSP}PM.jpg`,
  `Screenshot 2024-06-11 at 3.39.00${NNBSP}PM.jpg`,
  `Screenshot 2024-06-12 at 9.22.26${NNBSP}AM.jpg`,
  'pic1276900-gigapixel-standard-scale-6_00x.jpg',
  'pic56667.webp',
  'pic5792966.webp'
];

export function historyImageSrc(filename) {
  return `/legacy/history/${encodeURIComponent(filename)}`;
}
